import { createSvgIcon } from '@mui/material/utils';

const MetricPh = createSvgIcon(
  <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M23.5499 6.75066L6.53197 23.7685C5.89405 24.3994 5.03242 24.7522 4.13523 24.75C3.23805 24.7477 2.37819 24.3906 1.74344 23.7565C1.10731 23.1197 0.75 22.2564 0.75 21.3563C0.75 20.4561 1.10731 19.5928 1.74344 18.956L18.7493 1.95013M17.5492 0.75L24.75 7.95079M12.7487 17.5518H3.1476" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
,
  'MetricPh',
);

export default MetricPh;
